/** Mapeamento de rotas workspace → feature do plano do dono */
export const WORKSPACE_PLAN_ROUTE_FEATURES = {
  agenda: 'agenda',
  historia: 'taskHistoria',
  relatorios: 'crmRelatorios',
  financeiro: 'taskFinanceiro',
  atividade: 'taskControleAtividade',
  clientes: 'servicosClientes'
}

export const WORKSPACE_STAFF_ROUTES = ['usuarios', 'configuracoes', 'integracoes', 'financeiro', 'atividade']

export function parseWorkspaceRouteSegment (path) {
  const match = path.match(/\/workspace\/\d+\/([^/?]+)/)
  return match ? match[1] : null
}

export function getPlanFeatureForWorkspaceRoute (path, workspaceTipo) {
  const segment = parseWorkspaceRouteSegment(path)
  if (!segment) return null

  const tipo = String(workspaceTipo || '').trim().toUpperCase()

  if (segment === 'financeiro') {
    return tipo === 'SERVICOS' ? 'servicosFinanceiro' : 'taskFinanceiro'
  }

  if (segment === 'clientes') {
    return 'servicosClientes'
  }

  return WORKSPACE_PLAN_ROUTE_FEATURES[segment] || null
}

export function getPlanFeatureForPath (path) {
  return getPlanFeatureForWorkspaceRoute(path, null)
}

export function isStaffOnlyRoute (path) {
  const segment = parseWorkspaceRouteSegment(path)
  return segment && WORKSPACE_STAFF_ROUTES.includes(segment)
}
